export default __webpack_public_path__ + "static/10-a474f0914bf77e05715f46dde78f0c35.jpg";